import * as React from 'react';
import AjaxPromises from '../../utils/AjaxPromises';
import UserStore from '../../stores/UserStore';

class Banner extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            warningBanner: '',
            isOpen: true,
        };

        this.getBanner = this.getBanner.bind(this);
        this.closeBanner = this.closeBanner.bind(this);
    }

    async getBanner() {
        let resp = await AjaxPromises.POST('api/admin/get-banner', UserStore.getApiData({url: window.location.href}));

        if (resp && resp.Data && resp.Data[0] && resp.Data[0].banner) {
            if (sessionStorage.getItem('llxPOSBannerIsOpen') === null) {
                sessionStorage.setItem('llxPOSBannerIsOpen', 'true');
            }
            this.setState({ 
                warningBanner: resp.Data[0].banner, 
                isOpen: true, 
            });
        }
    }

    componentWillMount() {
        this.getBanner();
    }

    closeBanner() {
        sessionStorage.setItem('llxPOSBannerIsOpen', 'false');
        this.setState({ isOpen: false });
    }

    render() {
        return (
            <React.Fragment>
                {this.state.warningBanner.length > 0 && sessionStorage.getItem('llxPOSBannerIsOpen') === 'true' && (
                    <div className="banner">
                        <div className="banner__warningIcon">
                            <i className="fa fa-exclamation-triangle fa-2x"></i>
                        </div>
                        <div className="banner__body">
                            <span dangerouslySetInnerHTML={{__html: this.state.warningBanner}} />
                        </div>
                        <div
                            className='banner__body--close'
                            onClick={this.closeBanner}
                            data-testid='banner_close-div_close'
                        >
                            <i className='fa fa-times fa-2x' aria-hidden='true' />
                        </div>
                    </div>
                )}
            </React.Fragment>
        );
    }
}

export default Banner;



// WEBPACK FOOTER //
// ./ui_src/app/components/banner/banner.react.jsx